export default __webpack_public_path__ + "static/media/Intimation of Earnings Call.089c0e81.pdf";